import { render, staticRenderFns } from "./AddShooting.vue?vue&type=template&id=05f9c6f0"
import script from "./AddShooting.vue?vue&type=script&lang=js"
export * from "./AddShooting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports